<script setup lang="ts">
import { Divider as VarDivider, type DividerProps } from '@varlet/ui';

// eslint-disable-next-line vue/define-props-destructuring
const props = defineProps<DividerProps>();
</script>

<template>
  <VarDivider v-bind="props">
    <slot />
  </VarDivider>
</template>
